<template>
  <div class="content-wrap-mobile">
    <div class="result-info">
      <div :class="msgInfo.type === 'success' ? 'success-wrap' : 'error-wrap'">
        <div>
          <p class="order-status">{{ pageTitle }}</p>
          <p class="price"><span>￥</span>{{ textPrice }}</p>
        </div>
        <div class="order-info">
          <p class="item">
            <span class="title">课程名称</span
            ><span class="value">{{ textTitle }}</span>
          </p>
          <p class="item">
            <span class="title">交易单号</span
            ><span class="value">{{ orderInfo.order_no }}</span>
          </p>
        </div>
        <div v-if="msgInfo.type === 'success'" class="operate-wrap">
          <button class="order-btn" @click="jumpPage(linkTrade, 'orderList')">
            {{ textTrade }}
          </button>
          <button class="study-btn" @click="jumpPage(linkStudy, 'toStudy')">
            {{ textStudy }}
          </button>
        </div>
        <div v-else class="operate-wrap">
          <a class="study" :href="classDetailHref">返回课程</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { jsToFlutter } from "@saas/components/src/utils/js-to-flutter";
import { isHXApp } from "@saas/components/src";
export default {
  props: [
    "orderInfo",
    "msgInfo",
    "textPrice",
    "textTitle",
    "textTrade",
    "linkTrade",
    "textStudy",
    "linkStudy",
  ],
  computed: {
    pageTitle() {
      if (this.msgInfo.type === "success") {
        return "支付成功";
      } else if (this.orderInfo?.state === 4) {
        return "订单已关闭";
      } else {
        return "超时未支付";
      }
    },
    classDetailHref() {
      if (this.orderInfo?.course_id) {
        return `/product-detail/${this.orderInfo.course_id}`;
      } else if (
        this.orderInfo?.sub_order_list?.length === 1 &&
        this.orderInfo?.sub_order_list[0]?.course_id
      ) {
        return `/product-detail/${this.orderInfo?.sub_order_list[0].course_id}`;
      } else if (
        this.orderInfo?.sub_order_list?.length &&
        this.$route.query.goods_id
      ) {
        // 联报订单
        let goods = this.orderInfo.sub_order_list.filter((item) => {
          return item.goods_id === this.$route.query.goods_id;
        });
        if (goods?.length && goods[0].course_id) {
          return `/product-detail/${goods[0].course_id}`;
        } else {
          return "javascript:;";
        }
      } else {
        return "javascript:;";
      }
    },
  },
  data: function () {
    return {
      isHXApp: isHXApp(),
    };
  },
  methods: {
    jumpPage(url, type) {
      if (this.isHXApp) {
        jsToFlutter(type);
      } else {
        this.$router.push({ path: url });
      }
    },
  },
};
</script>
<style scoped lang="scss">
.content-wrap-mobile {
  width: 100%;
  text-align: center;
}

.success-wrap {
  .order-status {
    font-weight: 600;
    font-size: 0.52rem;
    color: #0d1400;
    line-height: 0.72rem;
    margin-bottom: 0.4rem;
  }
  .price {
    margin-bottom: 1.79rem;
    font-size: 1.07rem;
    line-height: 1.45rem;
    color: #0d1400;
    font-weight: 800;
    span {
      font-size: 0.53rem;
    }
  }
  .order-info .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.4rem;
    .title {
      font-weight: 400;
      font-size: 0.4rem;
      color: #747573;
      line-height: 0.56rem;
      margin-right: 0.6rem;
    }
    .value {
      text-align: right;
      flex: 1;
      width: 0;
      font-weight: 400;
      font-size: 0.4rem;
      color: #0d1400;
      line-height: 0.56rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .operate-wrap {
    max-width: 375px;
    width: 100%;
    padding: 0.32rem;
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .order-btn,
    .study-btn {
      border-radius: 0.32rem;
      width: 4.4rem;
      height: 1.33rem;
      font-weight: 500;
      font-size: 0.43rem;

      line-height: 1.33rem;
      text-align: center;
    }
    .study-btn {
      background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
      color: #ffffff;
    }
    .order-btn {
      color: #0d1400;
      background-color: #f7f8fa;
    }
  }
}
.error-wrap {
  .order-status {
    font-weight: 600;
    font-size: 0.52rem;
    color: #f03349;
    line-height: 0.72rem;
    margin-bottom: 0.4rem;
  }
  .price {
    margin-bottom: 1.79rem;
    font-size: 1.07rem;
    line-height: 1.45rem;
    color: #858687;
    font-weight: 800;
    span {
      font-size: 0.53rem;
    }
  }
  .order-info .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.4rem;
    .title {
      font-weight: 400;
      font-size: 0.4rem;
      color: #747573;
      line-height: 0.56rem;
      margin-right: 0.6rem;
    }
    .value {
      text-align: right;
      flex: 1;
      width: 0;
      font-weight: 400;
      font-size: 0.4rem;
      color: #747573;
      line-height: 0.56rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .operate-wrap {
    width: 100%;
    padding: 0.32rem;
    position: fixed;
    bottom: 0.8rem;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .study {
      padding: 0;
      width: 9.36rem;
      height: 1.33rem;
      font-weight: 500;
      font-size: 0.43rem;
      color: #ffffff;
      line-height: 1.33rem;
      text-align: center;
      background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
      border-radius: 0.32rem;
    }
  }
}
</style>
